import { defineStore } from "pinia";

import type {
  FeatureFlag,
  IKontaktorsak,
  IKundserviceAppApiClient,
} from "@/composables/KundserviceAppApiClient";

interface ConfigState {
  initialized: boolean;
  isLoading: boolean;
  featureFlags: FeatureFlag[];
  kontaktorsaker: IKontaktorsak[];
  ovrigaSamtalsamnen: IKontaktorsak[];
  error: Error | null;
}
export const useConfigStore = defineStore("config", {
  state: (): ConfigState => ({
    initialized: false,
    isLoading: false,
    featureFlags: [],
    kontaktorsaker: [],
    ovrigaSamtalsamnen: [],
    error: null,
  }),
  getters: {
    getFeatureFlag: (state: ConfigState) => (featureName: string) => {
      return state.featureFlags?.length > 0
        ? state.featureFlags.find(
            (feature: FeatureFlag) => feature.name == featureName,
          )?.isEnabled
        : false;
    },
    getKontaktorsakById: (state: ConfigState) => (id: string) =>
      state.kontaktorsaker.find((k) => k.id === id),
    getKontaktorsakOvrigt: (state: ConfigState) =>
      state.kontaktorsaker.find((k) => k.namn === "Övrigt"),
  },
  actions: {
    async init(apiClient: IKundserviceAppApiClient, forceRefresh = false) {
      if (this.initialized && !forceRefresh) {
        return;
      }

      this.isLoading = true;
      this.error = null;
      const { featureFlags, kontaktorsaker, ovrigaSamtalsamnen } =
        await apiClient.getConfig();
      this.featureFlags = featureFlags;
      this.kontaktorsaker = kontaktorsaker;
      this.ovrigaSamtalsamnen = ovrigaSamtalsamnen;
      this.initialized = true;
    },
  },
});
